(function () {
  var DEBOUNCE = 260;
  var MIN_CHARS = 2;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  var TrmQuickSearch = function () {
    var el = Reflect.construct(HTMLElement, [], TrmQuickSearch);
    return el;
  };
  TrmQuickSearch.prototype = Object.create(HTMLElement.prototype);

  TrmQuickSearch.prototype.connectedCallback = function () {
    var self = this;
    this.searchUrl = this.getAttribute('data-search-url') || '/search';
    this.resultsBox = this.querySelector('.trm-qs__results');
    this.suggestGroup = this.querySelector('.trm-qs__group--suggest');
    this.suggestList = this.querySelector('.trm-qs__list--suggest');
    this.catsGroup = this.querySelector('.trm-qs__group--cats');
    this.catsList = this.querySelector('.trm-qs__list--cats');
    this.viewAll = this.querySelector('.trm-qs__viewall');
    this.barInput = this.querySelector('.trm-qs__input');
    this.backBtn = this.querySelector('.trm-qs__back');
    this.activeInput = null;
    this.lastQuery = '';
    this.lastGoodQ = '';
    this.lastGoodFor = '';
    this.seq = 0;
    this.qCache = {};
    this.qCacheKeys = [];
    this.recCache = {};
    this.mobileQuery = window.matchMedia('(max-width: 1024px)');

    var runBar = debounce(function () { self.query(self.barInput); }, DEBOUNCE);
    this.barInput.addEventListener('input', function () { runBar(); });
    this.barInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var term = self.barInput.value.trim();
        if (term) {
          var q = (term === self.lastGoodFor && self.lastGoodQ) ? self.lastGoodQ : term;
          window.location.href = self.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
        }
      }
    });
    this.backBtn.addEventListener('click', function () { self.close(); });

    this.inputs = Array.prototype.filter.call(
      document.querySelectorAll('input[name="q"]'),
      function (inp) { return !inp.closest('.trm-gift-card__form'); }
    );

    var run = debounce(function (inp) { self.query(inp); }, DEBOUNCE);
    this.inputs.forEach(function (inp) {
      inp.setAttribute('autocomplete', 'off');
      if (inp.form && !inp.form.hasAttribute('data-trm-qs-form')) {
        inp.form.setAttribute('data-trm-qs-form', '');
        inp.form.addEventListener('submit', function (e) {
          var term = inp.value.trim();
          if (term && term === self.lastGoodFor && self.lastGoodQ && self.lastGoodQ !== term) {
            e.preventDefault();
            window.location.href = self.searchUrl + '?q=' + encodeURIComponent(self.lastGoodQ) + '&type=product';
          }
        });
      }
      inp.addEventListener('input', function () {
        if (self.isMobile()) { self.openMobile(inp); return; }
        run(inp);
      });
      inp.addEventListener('focus', function () {
        if (self.isMobile()) { self.openMobile(inp); return; }
        self.activeInput = inp;
        if (inp.value.trim().length >= MIN_CHARS) {
          if (self.hasAttribute('hidden')) run(inp);
        } else {
          self.showEmptyState();
        }
      });
    });

    this.trackViewedProduct();
    this.healSearchPage();

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('.header-mobile__item--search') : null;
      if (trigger && self.isMobile()) {
        e.preventDefault();
        e.stopPropagation();
        self.openMobile(null);
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (self.contains(e.target)) return;
      if (e.target.closest && (e.target.closest('input[name="q"]') || e.target.closest('#search-form-mobile') || e.target.closest('.header-mobile__item--search'))) return;
      if (self.activeInput && self.activeInput.contains && self.activeInput.contains(e.target)) return;
      self.close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.close();
    });
    window.addEventListener('resize', function () { if (!self.hasAttribute('hidden')) self.position(); });
  };

  TrmQuickSearch.prototype.isMobile = function () {
    return this.mobileQuery.matches;
  };

  TrmQuickSearch.prototype.placeViewAll = function () {
    var target = this.isMobile() ? this.querySelector('.trm-qs__main') : this.querySelector('.trm-qs__side');
    if (this.viewAll.parentElement !== target) target.appendChild(this.viewAll);
  };

  TrmQuickSearch.prototype.openMobile = function (sourceInput) {
    var drawer = document.querySelector('.search_details[open]');
    if (drawer) drawer.removeAttribute('open');
    document.body.classList.remove('open_search');
    var sidebarClose = document.querySelector('#search-form-mobile [class*="close"]');
    if (sidebarClose && document.getElementById('search-form-mobile').getBoundingClientRect().x === 0) {
      try { sidebarClose.click(); } catch (e) {}
    }
    if (sourceInput && sourceInput !== this.barInput) {
      this.barInput.value = sourceInput.value;
      try { sourceInput.blur(); } catch (e) {}
    }
    this.activeInput = this.barInput;
    document.body.classList.add('trm-qs-lock');
    this.removeAttribute('hidden');
    var term = this.barInput.value.trim();
    if (term.length >= MIN_CHARS) { this.query(this.barInput); } else { this.showEmptyState(); }
    this.barInput.focus();
  };

  TrmQuickSearch.prototype.close = function () {
    this.setAttribute('hidden', '');
    document.body.classList.remove('trm-qs-lock');
  };

  TrmQuickSearch.prototype.position = function () {
    if (this.isMobile()) { this.style.top = ''; return; }
    var anchor = (this.activeInput && this.activeInput !== this.barInput) ? this.activeInput.getBoundingClientRect() : { bottom: 120 };
    this.style.top = Math.round(Math.min(anchor.bottom + 10, window.innerHeight * 0.35)) + 'px';
  };

  TrmQuickSearch.prototype.readRecents = function () {
    try { return JSON.parse(localStorage.getItem('trm-qs-recent') || '[]'); } catch (e) { return []; }
  };

  TrmQuickSearch.prototype.saveRecent = function (term) {
    var list = this.readRecents().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    try { localStorage.setItem('trm-qs-recent', JSON.stringify(list.slice(0, 8))); } catch (e) {}
  };

  TrmQuickSearch.prototype.termLink = function (t) {
    var self = this;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = this.searchUrl + '?type=product&q=' + encodeURIComponent(t);
    var b = document.createElement('b');
    b.textContent = t;
    a.appendChild(b);
    a.addEventListener('click', function (e) {
      e.preventDefault();
      if (self.activeInput) {
        self.activeInput.value = t;
        self.activeInput.focus();
        self.query(self.activeInput);
      }
    });
    li.appendChild(a);
    return li;
  };

  TrmQuickSearch.prototype.renderNavCategories = function () {
    var self = this;
    var seen = {};
    var matches = [];
    var links = document.querySelectorAll('li.menu-lv-item.menu-lv-1 > a');
    Array.prototype.forEach.call(links, function (a) {
      if (matches.length >= 5) return;
      var text = (a.textContent || '').trim();
      var href = (a.getAttribute('href') || '').split('?')[0];
      if (!text || text.length > 40 || !href || href === '#' || seen[href]) return;
      if (/^前往|^View /i.test(text)) return;
      seen[href] = true;
      matches.push({ text: text, href: href });
    });
    this.catsList.innerHTML = '';
    matches.forEach(function (m) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = m.href;
      a.textContent = m.text;
      li.appendChild(a);
      self.catsList.appendChild(li);
    });
    if (matches.length) { this.catsGroup.removeAttribute('hidden'); } else { this.catsGroup.setAttribute('hidden', ''); }
  };

  TrmQuickSearch.prototype.showEmptyState = function () {
    var self = this;
    this.classList.remove('trm-qs--typing');
    this.lastQuery = '';
    this.seq++;
    var seq = this.seq;

    var recents = this.readRecents().slice(0, 5);
    this.suggestList.innerHTML = '';
    if (recents.length) {
      this.querySelector('.trm-qs__heading--suggest').textContent = this.getAttribute('data-recent-heading');
      recents.forEach(function (t) { self.suggestList.appendChild(self.termLink(t)); });
      this.suggestGroup.removeAttribute('hidden');
    } else {
      this.suggestGroup.setAttribute('hidden', '');
    }

    this.renderNavCategories();
    this.querySelector('.trm-qs__group--recs').setAttribute('hidden', '');
    this.viewAll.setAttribute('hidden', '');

    var mainHeading = this.querySelector('.trm-qs__heading--main');
    var viewed = this.readViewed().filter(function (p) { return p.url !== location.pathname; }).slice(0, 6);
    this.resultsBox.innerHTML = '';
    mainHeading.removeAttribute('hidden');
    if (viewed.length) {
      mainHeading.textContent = this.getAttribute('data-viewed-heading');
      viewed.forEach(function (p) { self.resultsBox.appendChild(self.buildCard(p)); });
    } else {
      mainHeading.textContent = this.getAttribute('data-results-heading');
      var ph = document.createElement('div');
      ph.className = 'trm-qs-empty';
      ph.textContent = this.getAttribute('data-placeholder') || '';
      this.resultsBox.appendChild(ph);
    }
    this.placeViewAll();
    this.position();
    this.removeAttribute('hidden');
  };

  TrmQuickSearch.prototype.readViewed = function () {
    try { return JSON.parse(localStorage.getItem('trm-qs-viewed') || '[]'); } catch (e) { return []; }
  };

  TrmQuickSearch.prototype.trackViewedProduct = function () {
    var node = document.getElementById('trm-qs-viewed-product');
    if (!node) return;
    var p = null;
    try { p = JSON.parse(node.textContent); } catch (e) { return; }
    if (!p || !p.url) return;
    var list = this.readViewed().filter(function (x) { return x.url !== p.url; });
    list.unshift(p);
    try { localStorage.setItem('trm-qs-viewed', JSON.stringify(list.slice(0, 8))); } catch (e) {}
  };

  TrmQuickSearch.prototype.buildCard = function (p) {
    var a = document.createElement('a');
    a.className = 'trm-qs-card';
    a.href = p.url;
    var imgBox = document.createElement('div');
    imgBox.className = 'trm-qs-card__img';
    if (p.image) {
      var img = document.createElement('img');
      img.src = p.image;
      img.alt = p.title;
      img.loading = 'lazy';
      img.width = 180;
      img.height = 180;
      imgBox.appendChild(img);
    } else {
      imgBox.className += ' trm-qs-card__img--empty';
      imgBox.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 2h4M10.5 2v3.5c0 .8-2.5 1.6-2.5 4V20a1.6 1.6 0 0 0 1.6 1.6h4.8a1.6 1.6 0 0 0 1.6-1.6V9.5c0-2.4-2.5-3.2-2.5-4V2"/></svg>';
    }
    a.appendChild(imgBox);
    var title = document.createElement('div');
    title.className = 'trm-qs-card__title';
    title.textContent = p.title;
    a.appendChild(title);
    var price = document.createElement('div');
    price.className = 'trm-qs-card__price';
    if (p.compare) {
      var s = document.createElement('s');
      s.textContent = p.compare;
      price.appendChild(s);
      price.appendChild(document.createTextNode(' '));
      var sale = document.createElement('span');
      sale.className = 'trm-qs-card__sale';
      sale.textContent = p.price;
      price.appendChild(sale);
    } else {
      price.textContent = p.price;
    }
    a.appendChild(price);
    var badge = document.createElement('span');
    badge.className = 'trm-qs-card__badge' + (p.available ? '' : ' trm-qs-card__badge--out');
    badge.textContent = this.getAttribute(p.available ? 'data-badge-in' : 'data-badge-out');
    a.appendChild(badge);
    return a;
  };

  TrmQuickSearch.prototype.starEachWord = function (term) {
    return term.split(/\s+/).map(function (t) {
      return t.slice(-1) === '*' ? t : t + '*';
    }).join(' ');
  };

  TrmQuickSearch.prototype.fetchResults = function (q, seq, cb) {
    var self = this;
    var url = this.searchUrl + '?view=trm_quick&type=product&q=' + encodeURIComponent(q);
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (seq !== self.seq) return;
        var m = html.match(/data-count="(\d+)"/);
        cb(html, m ? parseInt(m[1], 10) : 0);
      })
      .catch(function () {
        if (seq === self.seq) cb('', 0);
      });
  };

  TrmQuickSearch.prototype.healSearchPage = function () {
    var self = this;
    var section = document.querySelector('[data-section-type="search"][data-search-count]');
    if (!section) return;
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (!q) return;
    if (parseInt(section.getAttribute('data-search-count') || '0', 10) > 0) {
      this.cleanStarredDisplay(q);
      return;
    }
    if (q.indexOf('*') > -1 && /(^|[?&])filter\./.test(location.search)) {
      this.cleanStarredDisplay(q);
      return;
    }
    var alt = q.indexOf('*') > -1 ? q.replace(/\*/g, '') : this.starEachWord(q);
    if (alt === q) return;
    var mask = document.createElement('p');
    mask.className = 'trm-qs__healing';
    mask.textContent = this.getAttribute('data-searching') || '';
    section.style.display = 'none';
    section.parentNode.insertBefore(mask, section);
    this.fetchResults(alt, this.seq, function (html, count) {
      if (count > 0) {
        var ps = new URLSearchParams(location.search);
        ps.set('q', alt);
        ps.set('type', 'product');
        location.replace(self.searchUrl + '?' + ps.toString());
        return;
      }
      if (mask.parentNode) mask.parentNode.removeChild(mask);
      section.style.display = '';
    });
  };

  TrmQuickSearch.prototype.cleanStarredDisplay = function (q) {
    if (q.indexOf('*') === -1) return;
    var clean = q.replace(/\*/g, '').replace(/\s+/g, ' ').trim();
    if (!clean || clean === q) return;
    try {
      var ps = new URLSearchParams(location.search);
      ps.set('q', clean);
      history.replaceState({ searchParams: location.search.slice(1) }, '', location.pathname + '?' + ps.toString());
    } catch (e) {}
    this.replaceStarredText(q, clean);
    if (this.barInput && this.barInput.value === q) this.barInput.value = clean;
    this.hideStarsInHistory();
    this.watchStarredText(q, clean);
  };

  TrmQuickSearch.prototype.replaceStarredText = function (q, clean) {
    if (document.title.indexOf(q) > -1) document.title = document.title.split(q).join(clean);
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.indexOf(q) > -1) node.nodeValue = node.nodeValue.split(q).join(clean);
    }
    Array.prototype.forEach.call(document.querySelectorAll('input[name="q"]'), function (inp) {
      if (inp.type !== 'hidden' && inp.value === q) inp.value = clean;
    });
  };

  TrmQuickSearch.prototype.hideStarsInHistory = function () {
    if (window.trmQsHistoryWrapped) return;
    window.trmQsHistoryWrapped = true;
    var orig = history.pushState;
    history.pushState = function (state, title, url) {
      if (typeof url === 'string' && url) {
        try {
          var u = new URL(url, location.origin);
          var qv = u.searchParams.get('q');
          if (qv && qv.indexOf('*') > -1) {
            u.searchParams.set('q', qv.replace(/\*/g, ''));
            url = u.pathname + u.search;
          }
        } catch (e) {}
      }
      return orig.call(this, state, title, url);
    };
  };

  TrmQuickSearch.prototype.watchStarredText = function (q, clean) {
    var self = this;
    if (this.starWatcher) return;
    var pending = false;
    this.starWatcher = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        self.replaceStarredText(q, clean);
      }, 50);
    });
    this.starWatcher.observe(document.body, { childList: true, subtree: true });
  };

  TrmQuickSearch.prototype.query = function (inp) {
    var self = this;
    var term = inp.value.trim();
    this.activeInput = inp;
    if (term.length < MIN_CHARS) { this.showEmptyState(); return; }
    if (term === this.lastQuery && !this.hasAttribute('hidden')) return;
    this.lastQuery = term;
    var seq = ++this.seq;
    var hit = this.qCache[term];
    if (hit) {
      this.lastGoodQ = hit.q;
      this.lastGoodFor = term;
      this.render(term, hit.html);
      return;
    }
    var starred = this.starEachWord(term);
    this.fetchResults(starred, seq, function (html, count) {
      if (count > 0 || starred === term) {
        self.lastGoodQ = starred;
        self.lastGoodFor = term;
        self.remember(term, starred, html);
        self.render(term, html);
        return;
      }
      self.fetchResults(term, seq, function (html2) {
        self.lastGoodQ = term;
        self.lastGoodFor = term;
        self.remember(term, term, html2);
        self.render(term, html2);
      });
    });
  };

  TrmQuickSearch.prototype.remember = function (term, q, html) {
    if (!html) return;
    if (!this.qCache[term]) this.qCacheKeys.push(term);
    this.qCache[term] = { q: q, html: html };
    if (this.qCacheKeys.length > 30) delete this.qCache[this.qCacheKeys.shift()];
  };

  TrmQuickSearch.prototype.render = function (term, html) {
    var tpl = document.createElement('div');
    tpl.innerHTML = html;
    var frag = tpl.querySelector('.trm-qs-fragment');
    if (!frag) return;
    this.classList.add('trm-qs--typing');
    var mainHeading = this.querySelector('.trm-qs__heading--main');
    mainHeading.textContent = this.getAttribute('data-results-heading');
    mainHeading.removeAttribute('hidden');
    this.querySelector('.trm-qs__heading--suggest').textContent = this.getAttribute('data-suggest-heading');
    this.resultsBox.innerHTML = '';
    while (frag.firstChild) this.resultsBox.appendChild(frag.firstChild);

    var count = parseInt(frag.getAttribute('data-count') || '0', 10);
    if (count > 0) {
      this.saveRecent(term);
      this.viewAll.textContent = frag.getAttribute('data-view-all-label') || '';
      this.viewAll.setAttribute('href', frag.getAttribute('data-view-all-url') || '#');
      this.viewAll.removeAttribute('hidden');
      this.renderSuggestions(term);
      this.renderCategories(term);
      this.renderRecommendations(frag.getAttribute('data-first-id'));
    } else {
      this.viewAll.setAttribute('hidden', '');
      this.renderNoResults(term);
    }
    this.placeViewAll();
    this.position();
    this.removeAttribute('hidden');
  };

  TrmQuickSearch.prototype.renderNoResults = function (term) {
    var self = this;
    this.suggestGroup.setAttribute('hidden', '');
    this.catsGroup.setAttribute('hidden', '');
    this.querySelector('.trm-qs__group--recs').setAttribute('hidden', '');
    this.querySelector('.trm-qs__heading--main').setAttribute('hidden', '');
    var box = document.createElement('div');
    box.className = 'trm-qs__noresults';
    var msg = document.createElement('p');
    msg.className = 'trm-qs__noresults-msg';
    msg.textContent = (this.getAttribute('data-no-results-prefix') || '') + term + (this.getAttribute('data-no-results-suffix') || '');
    box.appendChild(msg);
    var seen = {};
    var chipsData = [];
    Array.prototype.forEach.call(document.querySelectorAll('li.menu-lv-item.menu-lv-1 > a'), function (a) {
      if (chipsData.length >= 5) return;
      var text = (a.textContent || '').trim();
      var href = (a.getAttribute('href') || '').split('?')[0];
      if (!text || text.length > 40 || !href || href === '#' || seen[href]) return;
      if (/^前往|^View /i.test(text)) return;
      seen[href] = true;
      chipsData.push({ text: text, href: href });
    });
    if (chipsData.length) {
      var tryMsg = document.createElement('p');
      tryMsg.className = 'trm-qs__noresults-try';
      tryMsg.textContent = this.getAttribute('data-try-these') || '';
      box.appendChild(tryMsg);
      var chips = document.createElement('div');
      chips.className = 'trm-qs__chips';
      chipsData.forEach(function (c) {
        var a = document.createElement('a');
        a.href = c.href;
        a.textContent = c.text;
        chips.appendChild(a);
      });
      box.appendChild(chips);
    }
    var seeAll = document.createElement('a');
    seeAll.className = 'trm-qs__seeall';
    seeAll.href = this.getAttribute('data-all-url') || '/collections/all';
    seeAll.textContent = this.getAttribute('data-see-all') || '';
    box.appendChild(seeAll);
    this.resultsBox.innerHTML = '';
    this.resultsBox.appendChild(box);
  };

  TrmQuickSearch.prototype.renderRecommendations = function (productId) {
    var self = this;
    var group = this.querySelector('.trm-qs__group--recs');
    group.setAttribute('hidden', '');
    if (!productId) return;
    if (this.recCache[productId]) {
      this.paintRecs(this.recCache[productId]);
      return;
    }
    var seq = this.seq;
    var base = this.searchUrl.replace(/\/search\/?$/, '');
    fetch(base + '/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        self.recCache[productId] = data.products || [];
        if (seq !== self.seq) return;
        self.paintRecs(self.recCache[productId]);
      })
      .catch(function () {});
  };

  TrmQuickSearch.prototype.paintRecs = function (products) {
    var group = this.querySelector('.trm-qs__group--recs');
    var list = this.querySelector('.trm-qs__list--recs');
    var shown = {};
    Array.prototype.forEach.call(this.resultsBox.querySelectorAll('a.trm-qs-card'), function (a) {
      shown[a.getAttribute('href').split('?')[0]] = true;
    });
    var recs = products.filter(function (p) {
      return !shown[(p.url || '').split('?')[0]];
    }).slice(0, 4);
    list.innerHTML = '';
    recs.forEach(function (p) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = p.url;
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=84';
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }
      var box = document.createElement('span');
      box.className = 'trm-qs__rec-title';
      box.textContent = p.title;
      var price = document.createElement('span');
      price.className = 'trm-qs__rec-price';
      price.textContent = '$' + (p.price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      box.appendChild(price);
      a.appendChild(box);
      li.appendChild(a);
      list.appendChild(li);
    });
    if (recs.length) group.removeAttribute('hidden');
  };

  TrmQuickSearch.prototype.renderSuggestions = function (term) {
    var titles = Array.prototype.map.call(
      this.resultsBox.querySelectorAll('.trm-qs-card__title'),
      function (t) { return t.textContent; }
    );
    var lower = term.toLowerCase();
    var phrases = {};
    titles.forEach(function (title) {
      var words = title.split(/\s+/);
      for (var i = 0; i < words.length; i++) {
        if (words[i].toLowerCase().indexOf(lower) === 0) {
          var next = words.slice(i + 1, i + 3).join(' ').replace(/[|,()]/g, '').trim();
          if (next) {
            var phrase = words[i] + ' ' + next;
            phrases[phrase] = (phrases[phrase] || 0) + 1;
          }
        }
      }
    });
    var top = Object.keys(phrases).sort(function (a, b) { return phrases[b] - phrases[a]; }).slice(0, 3);
    this.suggestList.innerHTML = '';
    var self = this;
    top.forEach(function (p) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = self.searchUrl + '?type=product&q=' + encodeURIComponent(p);
      var b = document.createElement('b');
      b.textContent = p;
      a.appendChild(b);
      li.appendChild(a);
      self.suggestList.appendChild(li);
    });
    if (top.length) { this.suggestGroup.removeAttribute('hidden'); } else { this.suggestGroup.setAttribute('hidden', ''); }
  };

  TrmQuickSearch.prototype.renderCategories = function (term) {
    var lower = term.toLowerCase();
    var seen = {};
    var matches = [];
    var links = document.querySelectorAll('.site-nav a[href*="/collections/"], header a[href*="/collections/"], .header a[href*="/collections/"]');
    Array.prototype.forEach.call(links, function (a) {
      if (matches.length >= 4) return;
      var text = (a.textContent || '').trim();
      var href = a.getAttribute('href') || '';
      if (!text || text.length > 40) return;
      if (text.toLowerCase().indexOf(lower) === -1 && href.toLowerCase().indexOf(lower) === -1) return;
      var key = href.split('?')[0];
      if (seen[key]) return;
      seen[key] = true;
      matches.push({ text: text, href: key });
    });
    this.catsList.innerHTML = '';
    var self = this;
    matches.forEach(function (m) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = m.href;
      a.textContent = m.text;
      li.appendChild(a);
      self.catsList.appendChild(li);
    });
    if (matches.length) { this.catsGroup.removeAttribute('hidden'); } else { this.catsGroup.setAttribute('hidden', ''); }
  };

  if (!window.customElements.get('trm-quick-search')) {
    window.customElements.define('trm-quick-search', TrmQuickSearch);
  }
})();
